angular.module('aq.filters').filter('sumArrayByKey', function() {
    return function(list, key) {
        return _.sumArrayByKey(list, key);
    }
});